import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css              */
const CardText = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement(Text, { className: classnames("card-text", className), ...rest }, children);
export {
  CardText as default
};
//# sourceMappingURL=CardText.js.map
